export default __webpack_public_path__ + "static/media/compliance.744a24d8.svg";